import QRCodeVariantBDev from "@/assets/images/qr-codes/app_store_qr_b_dev.png";
import QRCodeVariantBProd from "@/assets/images/qr-codes/app_store_qr_b_prod.png";
import QRCodeVariantBQa from "@/assets/images/qr-codes/app_store_qr_b_qa.png";
import QRCodeVariantBStg from "@/assets/images/qr-codes/app_store_qr_b_stg.png";
import ProcessEnvironment from "@/constants/ProcessEnvironment";

// PNG imports resolve to the bundler's asset reference (a URL string on web,
// a numeric module id on native) — mirror that type rather than ImageSourcePropType
type QRCodeSource = typeof QRCodeVariantBProd;

// Environment-specific "variant B" App Store QR codes. Each encodes the
// environment's deep-link/redirect target (the deep-link routing itself is handled
// separately). Keyed by EnvironmentType (literal keys mirror EnvironmentTypes in
// app.environments.js, which can't export types) so the map stays exhaustive; envs
// without a dedicated QR (local/labs/test) fall back to production, the safest UX.
const EnvironmentQRCode: Record<EnvironmentType, QRCodeSource> = {
  dev: QRCodeVariantBDev,
  labs: QRCodeVariantBProd,
  local: QRCodeVariantBProd,
  prod: QRCodeVariantBProd,
  qa: QRCodeVariantBQa,
  stg: QRCodeVariantBStg,
  test: QRCodeVariantBProd,
};

const isEnvironmentType = (env: string): env is EnvironmentType =>
  Object.hasOwn(EnvironmentQRCode, env);

/**
 * Returns the App Store QR code image for the current deployment environment.
 * Defaults to the production QR code (the safest UX) for an unrecognized env.
 */
const getEnvironmentQRCode = (): QRCodeSource => {
  const env = ProcessEnvironment.DeploymentEnvironment;
  return isEnvironmentType(env) ? EnvironmentQRCode[env] : QRCodeVariantBProd;
};

export { getEnvironmentQRCode };
